import React, {useState, useEffect} from 'react';
import {Modal, Table, Badge} from "react-bootstrap";

import Loader from "../Loader";

const formatDateTime = (datetime) => datetime ? datetime.slice(0, 19).replace('T', ' ') : '';

const HISTORY_TYPES = {
    scan: {label: 'Сканування', variant: 'info'},
    pass: {label: 'Прохід', variant: 'success'},
};

const TicketDetailModal = ({number, show, onHide}) => {
    const [ticket, setTicket] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!show || !number) return;
        setTicket(null);
        setError(null);
        setIsLoading(true);

        const fetchTicket = async () => {
            const token = window.sessionStorage.getItem('token');
            const response = await fetch(`/ticket/${number}/`, {
                method: 'GET',
                headers: {'Authorization': `Token ${token}`},
            });
            const responseJson = await response.json();
            if (response.status === 200) {
                setTicket(responseJson);
            } else {
                setError(responseJson);
            }
            setIsLoading(false);
        };

        fetchTicket();
    }, [number, show]);

    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Квиток №{number}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isLoading && <Loader />}
                {error && <p>{error}</p>}
                {ticket && (
                    <>
                        <ul>
                            <li><b>Статус:</b> {ticket.status}</li>
                            <li><b>Тип:</b> {ticket.service.name}</li>
                            <li><b>Вартість:</b> {ticket.cost}</li>
                            <li><b>Касир:</b> {ticket.cash_desk}</li>
                            <li><b>Придбано:</b> {formatDateTime(ticket.created_at)}</li>
                            {ticket.used_at && <li><b>Використано:</b> {formatDateTime(ticket.used_at)}</li>}
                            <li><b>Дійсний до:</b> {ticket.valid_until}</li>
                        </ul>

                        <h6 style={{marginTop: '16px'}}>Історія сканувань та проходів</h6>
                        {ticket.history && ticket.history.length > 0 ? (
                            <Table striped bordered hover size="sm">
                                <thead>
                                <tr>
                                    <th>Час</th>
                                    <th>Подія</th>
                                    <th>Статус</th>
                                    <th>Сканер</th>
                                </tr>
                                </thead>
                                <tbody>
                                {ticket.history.map((e, i) => {
                                    const type = HISTORY_TYPES[e.type] || {label: e.type, variant: 'secondary'};
                                    return (
                                        <tr key={i}>
                                            <td>{e.timestamp}</td>
                                            <td><Badge variant={type.variant}>{type.label}</Badge></td>
                                            <td>{e.status}</td>
                                            <td>{e.scanner}</td>
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </Table>
                        ) : (
                            <p>Записів немає.</p>
                        )}
                    </>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default TicketDetailModal;
